import React, { useEffect, useRef, useState } from "react";
import { isMobile } from "../../component/function/function";
import { useParams } from "react-router-dom";
import { TopNav2 } from "../../component/mobile/Topnav";
import styled from "styled-components";
import ReportService from "../../service/report/reportApi";
import TractorEfficiency from "./Result/TractorEfficiency";
import Economy from "./Result/Economy";
import {
  ReportFarmEconomic,
  ReportSummary,
  ReportTractorEfficiency,
} from "./machine";
import { fromM2 } from "./function";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const tabList = ["트랙터/부속기 최적화", "농업 경제성"];

function MachineReportResult({
  reportIdx,
  setClose,
  search,
  setOnPointHistory,
  setCloseSearchPointDetail,
  mypage,
}: any) {
  let param: any;
  const param2 = useParams();

  const [areaType, setAreaType] = useState("P");
  const [activeTab, setActiveTab] = useState("트랙터/부속기 최적화");

  const [summary, setSummary] = useState<ReportSummary>();
  const [tractorEfficiency, setTractorEfficiency] =
    useState<ReportTractorEfficiency>();
  const [farmEconomic, setFarmEconomic] = useState<ReportFarmEconomic>();

  if (isMobile(window.innerWidth)) {
    param = { reportIdx: param2.reportIdx };
  } else {
    param = { reportIdx: reportIdx };
  }

  const scrollRef = useRef<HTMLDivElement | null>(null);
  const printRef = useRef<HTMLDivElement | null>(null);

  const getReport = async () => {
    try {
      const data = await ReportService.getReport(param.reportIdx);
      setSummary(data.result.report_desc);
      setTractorEfficiency(data.result.tractorEfficiency);
      setFarmEconomic(data.result.farmEconomic);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getReport();
  }, []);

  const handleSavePdf = async () => {
    if (!printRef.current) return;

    const element = printRef.current;

    try {
      // 스크롤 있는 요소는 전체 높이 캡처를 위해 옵션 약간 조정
      const canvas = await html2canvas(element, {
        scale: 2, // 해상도 ↑
        useCORS: true, // 이미지 crossOrigin 있을 때
        // scrollY: -window.scrollY, // 현재 스크롤 보정
      });
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save("트랙터_부속기_효율_보고서.pdf");
    } catch (e) {
      console.error(e);
      alert("PDF 생성 중 오류가 발생했습니다.");
    }
  };

  useEffect(() => {
    const original = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = original;
    };
  }, []);

  return (
    <Wrapper>
      {summary && tractorEfficiency && farmEconomic && (
        <div style={{ position: "absolute", left: "-9999px", top: 0 }}>
          <PrintInner ref={printRef}>
            {/* 위쪽 요약 정보는 그대로 재사용해도 되고, 간단 버전으로 */}
            <InfoSection>
              <InfoItem>
                <div className="label">주소</div>
                <div className="value">{summary.address}</div>
              </InfoItem>
              <InfoItem>
                <div className="label">영농 면적</div>
                <div className="value">
                  {fromM2(summary.area, "평")}평 / {summary.area}㎡
                </div>
              </InfoItem>
              <InfoItem>
                <div className="label">내 작물</div>
                <div className="value">{summary.crop}</div>
              </InfoItem>
            </InfoSection>

            {/* 1페이지: 트랙터/부속기 최적화 */}
            <TractorEfficiency data={tractorEfficiency} hideInnerTabs />

            {/* 페이지 나누고 싶으면 강제 page break */}
            <div style={{ pageBreakBefore: "always" }} />

            {/* 2페이지: 농업 경제성 */}
            <Economy data={farmEconomic} crops={summary.crops} hideInnerTabs />
          </PrintInner>
        </div>
      )}

      {!search ? (
        <TopNav2
          browser
          text="트랙터/부속기 효율 보고서"
          closeBack
          close
          mypage={mypage}
          setClose={setClose}
        />
      ) : (
        <div className="flex-row space-between padding-12-16 center-y">
          <img
            src="/asset/images/arrow/arrowBack.svg"
            alt="arrow"
            className="pointer"
            onClick={() => {
              setCloseSearchPointDetail(false);
            }}
          />
          <div className="m-b1-16-b color-dark-primary">
            트랙터/부속기 효율 보고서
          </div>
          <img
            src="/asset/images/close/CloseBlack24.svg"
            className="pointer"
            alt="close"
            onClick={() => {
              if (mypage) {
              } else {
                setCloseSearchPointDetail(false);
                setOnPointHistory(false);
              }
            }}
          />
        </div>
      )}
      {summary && tractorEfficiency && farmEconomic && (
        <Inner ref={scrollRef}>
          <InfoSection>
            <InfoItem>
              <div className="label">주소</div>
              <div className="value">{summary.address}</div>
            </InfoItem>
            <InfoItem>
              <div className="label">영농 면적</div>
              <div className="value">
                {areaType === "M" ? summary.area : fromM2(summary.area, "평")}
                {areaType === "M" ? "㎡" : "평"}
              </div>
              <div
                className="hover bg-FFFFFF padding-2-8 cneter-x center-y flex-row border-radius-100 border-1-e2e2e2 font-medium f-size-12 line-h-20 color-text-tertiary"
                onClick={() =>
                  setAreaType((prev) => (prev !== "P" ? "P" : "M"))
                }
              >
                <img src="/asset/images/arrow/Refresh20.svg" alt="" />
                {areaType === "P" ? "㎡" : "평"}
              </div>
            </InfoItem>
            <InfoItem>
              <div className="label">내 작물</div>
              <div className="value">{summary.crop}</div>
            </InfoItem>
          </InfoSection>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <TabContainer>
              {tabList.map((t) => (
                <Tab
                  key={t}
                  $active={activeTab === t}
                  onClick={() => {
                    setActiveTab(t);
                    scrollRef?.current?.scrollTo({
                      top: 0,
                      behavior: "smooth",
                    });
                  }}
                >
                  {t}
                </Tab>
              ))}
            </TabContainer>
            {activeTab === "트랙터/부속기 최적화" ? (
              <TractorEfficiency
                scrollContainerRef={scrollRef}
                data={tractorEfficiency}
              />
            ) : (
              <Economy
                scrollContainerRef={scrollRef}
                data={farmEconomic}
                crops={summary.crops}
              />
            )}
          </div>
          <SaveButtonContainer>
            <SaveButton onClick={handleSavePdf}>보고서 저장하기</SaveButton>
          </SaveButtonContainer>
        </Inner>
      )}
    </Wrapper>
  );
}

export default MachineReportResult;

const Wrapper = styled.div`
  height: 100vh; /* 뷰포트 전체 높이 */
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f7f8f9;
`;

const PrintInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  /* overflow, height 없음!! */
  background: #fff;
  width: 794px; /* A4 세로 기준 (선택) */
`;

const InfoSection = styled.div`
  display: flex;
  width: 100%;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  background: #fff;
`;

const InfoItem = styled.div`
  display: flex;
  padding: 8px 0;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-bottom: 1px solid rgba(23, 30, 38, 0.1);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;

  & > .label {
    color: var(--Alias-Color-Text-Dark-Text-Tertiary, rgba(23, 30, 38, 0.56));
  }

  & > .value {
    flex: 1 0 0;
    color: var(--Alias-Color-Text-Dark-Text-Secondary, rgba(23, 30, 38, 0.78));
    text-align: right;
  }
`;

const Inner = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  height: 100%;
`;

const TabContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 90;
  background-color: #fff;

  display: flex;
  padding: 12px 16px 0;
  align-items: flex-start;
  align-self: stretch;
  background: #fff;
  border-bottom: rgba(23, 30, 38, 0.1);
`;

const Tab = styled.div<{ $active?: boolean }>`
  cursor: pointer;
  display: flex;
  padding: 8px 0;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  color: rgba(23, 30, 38, 0.4);
  font-feature-settings:
    "liga" off,
    "clig" off;

  /* Mo/Title/S-18-Bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; /* 144.444% */
  letter-spacing: -0.18px;

  ${({ $active }) =>
    $active &&
    `
  color:#171E26;
  border-bottom: 2px solid var(--Alias-Color-Text-Dark-Text-Primary, #171E26);
`}
`;

const SaveButtonContainer = styled.div`
  display: flex;
  padding: 24px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
`;

const SaveButton = styled.button`
  border: none;
  outline: none;
  cursor: pointer;

  display: flex;
  padding: 14px 16px;
  justify-content: center;
  align-items: center;
  gap: 2px;
  align-self: stretch;
  border-radius: 8px;
  background: var(--Alias-Color-Button-cta-light-background-Primary, #1e9b6b);

  color: var(--Alias-Color-Text-White-Text-Primary, #fff);
  text-align: center;
  font-feature-settings:
    "liga" off,
    "clig" off;

  /* Mo/Body/S-14-Bold */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px; /* 142.857% */
`;
